(function ($) {
  var $ = jQuery = $;

  gsap.registerPlugin(ScrollTrigger);
  gsap.registerPlugin(CSSRulePlugin);

  // const chevronRight = '<svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0-.25H24v24H0Z" transform="translate(0 0.25)" style="fill:none"></path><polyline points="10 17.83 15.4 12.43 10 7.03" style="fill:none;stroke:currentColor;stroke-linecap:round;stroke-miterlimit:8;stroke-width:1.5px"></polyline></svg>';
  // const chevronLeft = '<svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0-.25H24v24H0Z" transform="translate(0 0.25)" style="fill:none"/> <polyline points="14.4 7.03 9 12.43 14.4 17.83" style="fill:none;stroke:currentColor;stroke-linecap:round;stroke-miterlimit:8;stroke-width:1.5px"/></svg>';
  
  
  
  // product pages - move tabs down below product.
  if ( $('.product-tab-holder').length ) {
   	$('.product-tab-holder').append( $('.product-detail__tab-container') ); 
    $('.cc-tabs__tab-headers__header').each(function(){
      
      const tab = $('#'+$(this).attr('aria-controls'));
      let tabcontent = tab.text().replace(/\s/g,'');
      const thistab = $(this).text().trim();
      // console.log(thistab+': '+tabcontent.length);
      if (thistab==='Reviews'){
        // leave it. loads async
      } else if (thistab==='FAQ'){
        $(this).parent().addClass('hidden'); // hide it first.
        // console.log('observe',tab[0].children[0]);
        // loads async but we don't know if it will contain content!
        var _this = $(this);
        var observer = new MutationObserver(function(mutations) {
            // console.log(mutations);   
            if (mutations[0].type==='childList' && mutations[0].target.classList.contains('coca-accordion-main')) {
              // console.log('show!',_this);
              _this.parent().removeClass('hidden');
            }
        });
        observer.observe(tab[0].children[0],{childList:true,subtree:true});


      } else if (tabcontent.length===0){
        // console.log('hide',thistab);
        $(this).parent().addClass('hidden');
      }
    })
  }

  // trigger carousel for product pages containing recipes
  if ( $('.product-recipe-carousel').length ) {
    // watch for tab change. initialize slick only after tab change.
    const parent_cc = $('.product-recipe-carousel').parent();
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === "attributes") {
          // console.log("attributes changed",mutation);
          theme.initContentSlider( $('.product-recipe-carousel') );
          observer.disconnect();
        }
      });
    });
    observer.observe(parent_cc[0], { attributes:true });
  }

  // newsletter source
  if ( $('body').hasClass('page-newsletter-signup') ){
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const tags = $('input[name="contact[tags]"]');
    // console.log(tags,urlParams.get('src'));
    if (urlParams.get('src')){
      let ctags = tags.val();
      tags.val(ctags+','+urlParams.get('src'));
    }
  }

  // customize insta feed on home page.
  const instasection = $('#insta-feed').parent();
  instasection.addClass('shopify-section-insta');

  // set up mobile dropdown filters
  $('.mb-dropdown, .cc-tabs').on('click',function(){
    $(this).toggleClass('active');
  })
  $('.cc-tabs__tab-headers__header').on('click',function(){
    $('.mb-tab-header').html($(this).html());
  })

  // set up parallax elements.
  $('.p-lax-img').each(function(){
    const targ = $(this).data('target');
    const align = $(this).data('alignment');
    const pseudo = align==='left' ? 'before' : 'after';
    const amount = $(this).data('amount');
    console.log(targ,align);
    const rule = CSSRulePlugin.getRule(targ+'::'+pseudo);
    gsap.fromTo(rule, {top:-amount+'px'}, {
      top:amount+'px',
      scrollTrigger: {
        trigger: targ,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true
      }
    })
  })

  // hero animation.
  if ($('.hero-animation').length){
    // gsap.from('.hero-0',{y:50,
    //   scrollTrigger: {
    //     trigger:'.hero-animation',
    //     start: 'top top',
    //     end: 'bottom top',
    //     scrub: true
    //   }});
    gsap.fromTo('.hero-1',{y:30},{y:0,
      scrollTrigger: {
        trigger:'.hero-animation',
        start: 'top top',
        end: 'bottom top',
        scrub: true
      }});
    gsap.fromTo('.hero-2',{y:80},{y:0,
      scrollTrigger: {
        trigger:'.hero-animation',
        start: 'top top',
        end: 'bottom top',
        scrub: true
      }});
    gsap.fromTo('.hero-3',{y:150},{y:0,
      scrollTrigger: {
        trigger:'.hero-animation',
        start: 'top top',
        end: 'bottom top',
        scrub: true
      }});
    // const tl = gsap.timeline();
    // tl.from('.flicker-layer',{opacity:0,duration:.5},"+=1");
    // tl.to('.flicker-layer',{opacity:0,duration:.05});
    // tl.to('.flicker-layer',{opacity:1,duration:.05});
    // tl.to('.flicker-layer',{opacity:0,duration:.05});
    // tl.to('.flicker-layer',{opacity:1,duration:.05});
    // tl.to('.flicker-layer',{opacity:0,duration:.05});
    // tl.to('.flicker-layer',{opacity:1,duration:.05});
    // tl.to('.flicker-layer',{opacity:0,duration:.05});
    // tl.to('.flicker-layer',{opacity:1,duration:.05});
    // tl.from('.float-layer',{y:300,ease:Back.easeOut,duration:2},"+=1");
  }
  
})(theme.jQuery);  
